import * as React from 'react';
import Button from '@telia-front/button';
import Grid, { GridColumn } from '@telia-front/grid';
import Icon from '@telia-front/icon';
import { TableCell, TableRow } from '@telia-front/table';
import Text from '@telia-front/text';
import { TvComparisonContext } from './index';
import ChannelPriceTableCell from './channel-price-table-cell';
const DesktopViewerSlotRow = (props) => {
    const { slot, numberOfPackets } = props;
    const { showMoreLabel, showLessLabel } = React.useContext(TvComparisonContext);
    const [showAll, setShowAll] = React.useState(false);
    return (React.createElement(TableRow, { background: "neutral-1", id: slot.id },
        React.createElement(TableCell, { width: numberOfPackets <= 1 ? 4 : 3, className: "text" },
            React.createElement(Grid, { noWrap: true, align: ['middle-xs'], gutter: "small" },
                slot.icon && (React.createElement(GridColumn, { width: ['min'] },
                    React.createElement(Icon, { size: "md", modifiers: slot.icon, className: "visible" }))),
                React.createElement(GridColumn, { width: ['max'] },
                    React.createElement("p", { className: "text-bold" }, slot.title))),
            slot.description && showMoreLabel && showLessLabel && (React.createElement(Text, null,
                showAll && React.createElement("div", null, slot.description),
                React.createElement(Button, { link: true, text: showAll ? showLessLabel : showMoreLabel, iconRight: showAll ? '#arrow-up' : '#arrow-down', onClick: () => setShowAll(!showAll) })))),
        slot.packetPrices &&
            slot.packetPrices.map((price, index) => React.createElement(ChannelPriceTableCell, { price: price, width: numberOfPackets <= 1 ? 2 : 3, key: index, variant: "secondary" })),
        slot.packetInfos &&
            slot.packetInfos.map((info, index) => {
                return (React.createElement(TableCell, { width: numberOfPackets <= 1 ? 2 : 3, valign: "middle", key: index }, info));
            })));
};
export default DesktopViewerSlotRow;
